import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KeyCodeWithModifiersyrb06kjwhumy as KeyCodeWithModifiers } from '../models/KeyCode.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../models/data.commonHtml.mjs';
import { WindowStatisticscvqq0mhzo3xj as WindowStatistics } from '../models/WindowStatistics.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { reactiveProcess2z4nh4eb606pm as reactiveProcess } from '../../../../../reactive/com/lightningkite/reactive/core/processes.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  _LanguageCode___init__impl__2a1w642yl3nbtrv09kx as _LanguageCode___init__impl__2a1w64,
  LanguageCode15w5ectz557tc as LanguageCode,
} from '../locale/models.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function AppState$_lastUniversalKeyboardInput$slambda() {
  return constructCallableReference(($this$reactiveProcess, $completion) => orPromise($completion, function *($completion) {
    var l = (ev) => {
      if (!(ev instanceof KeyboardEvent))
        THROW_CCE();
      $this$reactiveProcess.emit_kpj8i4_k$(new (KeyCodeWithModifiers())(ev.code, ev.altKey, ev.ctrlKey, ev.shiftKey, ev.metaKey));
      return Unit_instance;
    };
    window.addEventListener('keydown', l);
    var tmp;
    try {
      // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
      // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
      (yield () => {
        var uCont = $completion;
        var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
        cancellable.initCancellability_shqc60_k$();
        return cancellable.getResult_fck196_k$();
      });
      tmp = Unit_instance;
    }finally {
      window.removeEventListener('keydown', l);
    }
    return Unit_instance;
  }), 1);
}
var AppStateClass;
function AppState() {
  if (AppStateClass === VOID) {
    class $ {
      constructor() {
        AppState_instance = this;
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (WindowStatistics())(get_px(window.innerWidth), get_px(window.innerHeight), window.devicePixelRatio));
        var it = this_0;
        var tmp_0 = window;
        tmp_0.addEventListener('resize', (ev) => {
          var newwidth = get_px(window.innerWidth);
          var newheight = get_px(window.innerHeight);
          var tmp;
          if (!equals(it.get_value_j01efc_k$().width_1, newwidth) || !equals(it.get_value_j01efc_k$().height_1, newheight)) {
            it.set_value_v1vabv_k$(new (WindowStatistics())(newwidth, newheight, window.devicePixelRatio));
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        tmp._windowInfo_1 = this_0;
        this._softInputOpen_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
        var tmp_1 = this;
        // Inline function 'kotlin.also' call
        var this_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(currentSystemLanguages());
        var signal = this_1;
        var tmp_2 = window;
        tmp_2.addEventListener('languagechange', (_unused_var__etf5q3) => {
          signal.set_value_v1vabv_k$(currentSystemLanguages());
          return Unit_instance;
        });
        tmp_1._systemLanguages_1 = this_1;
        this.currentLock_1 = null;
        this.currentLockCount_1 = 0;
        var tmp_3 = this;
        tmp_3._lastUniversalKeyboardInput_1 = reactiveProcess(VOID, AppState$_lastUniversalKeyboardInput$slambda());
      }
      get_windowInfo_amgsav_k$() {
        return this._windowInfo_1;
      }
      onUniversalKeyboard_3hqcjo_k$(handler) {
        var l = (ev) => {
          if (!(ev instanceof KeyboardEvent))
            THROW_CCE();
          var tmp;
          if (handler(new (KeyCodeWithModifiers())(ev.code, ev.altKey, ev.ctrlKey, ev.shiftKey, ev.metaKey))) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
        window.addEventListener('keydown', l);
        return () => {
          window.removeEventListener('keydown', l);
          return Unit_instance;
        };
      }
    }
    initMetadataForObject($, 'AppState');
    AppStateClass = $;
  }
  return AppStateClass;
}
var AppState_instance;
function AppState_getInstance() {
  if (AppState_instance === VOID)
    new (AppState())();
  return AppState_instance;
}
function currentSystemLanguages() {
  var languages = window.navigator.languages;
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.collections.isEmpty' call
  if (!(languages.length === 0)) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(languages.length);
    var inductionVariable = 0;
    var last = languages.length;
    while (inductionVariable < last) {
      var item = languages[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$4 = new (LanguageCode())(_LanguageCode___init__impl__2a1w64(item));
      destination.add_utx5q5_k$(tmp$ret$4);
    }
    tmp = destination;
  } else {
    tmp = listOf(new (LanguageCode())(_LanguageCode___init__impl__2a1w64(window.navigator.language)));
  }
  return tmp;
}
//region block: exports
export {
  AppState_getInstance as AppState_getInstance33x03n2an9aul,
};
//endregion

//# sourceMappingURL=AppState.js.mjs.map
